import { generateStripeState } from '../helper'

const options = {
  api: {
    list: () => `/api/stripe/payments`,
    delete: ({ id }) => `/api/stripe/payment/${id}`,
    update: ({ id }) => `/api/stripe/payment/${id}`,
    create: () => `/api/stripe/payment`,
    get: ({ id }) => `/api/stripe/payment/${id}`,
  },
  state: {
    collectionName: 'payments'
  },
  getters: {
    getPagination: 'getPaymentPagination',
    getCollection: 'getPayments'
  },
  actions: {
    list: 'listPayments',
    delete: 'deletePayment',
    update: 'updatePayment',
    create: 'createPayment',
    get: 'getPayment'
  },
  mutationKey: 'PAYMENT'
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)


export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  actions:{
    ...stripeActions
  },
  mutations:{
    ...stripeMutations
  }
}
